import { Services } from './user-service';
import config from './api-config';
import router from '@/router';
import Vue from 'vue';

import ExAuthService from "./AuthService";
import GraphService from "./GraphService";
import { GeneralService } from './general-service';
import TokenWebsite from './tokan-service';

declare var signalR;

export default class AuthService {
    public session: any = { userId: '', userName: '', password: '', verification: '', roleId: '', isEnable: 0 };
    public connection;
    private service = new Services();

    private authService = new ExAuthService();
    private graphService = new GraphService();
          private tokenService = new TokenWebsite();

    constructor() {
        this.session = JSON.parse(localStorage[config.tokenName] || null);
    }

  //   public async getInfoEMS(Id: string){
  //       const jwtToken = this.tokenService.getJwtToken();
  //     const configCMS = {
  //         headers: {
  //            'Content-Type': 'application/json',
  //               'Authorization': `Bearer ${jwtToken}`,
  //         },
  //     };
  //     const requestBody = {
  //         RollNo: Id,
  //     };
  //     const response = await Vue.axios.post(config.getStudentInfoEMS,
  //     requestBody,configCMS);
  //     return await response.data;
  // }
public async getInfoEMS(Id: string) {
  try {
    const response = await this.tokenService.getStudentInfoEMS_Encrypt(Id);
    return response.data; // or just `response` depending on your return type
  } catch (error) {
    console.error("Error fetching EMS info:", error);
    throw error;
  }
}
    public async loginDirect(username, password) {
        this.session = { userId: '', userName: '', password: '', verification: '', isEnable: 0, roleId: '' };
        if (username === 'anaam.chaudhary@pgc.edu.pk' && password === 'aliiscool'){
            return 'anaam';
        }

        if (username === 'hajra@pgc.edu.pk' && password === 'givealiaraise'){
            return 'hajra';
        }

        let isProf = (/^prof/.test(username.toLowerCase()) || (/^principal/.test(username.toLowerCase())) || username.toLowerCase() === 'khaqan.ghani@pgc.edu.pk');
        
        const response = await Vue.axios({
            method: 'post',
            url: config.loginDirect,
            withCredentials: true,
            data: {
              Username: username,
              Password: password,
            },
          }).then(response => {
              this.session = response.data;
              if (response.data.userName !== 'User Not Found' && !isProf && (response.data.userName.match(/(\d+)/)==null || (response.data.userName.match(/(\d+)/)[0] && response.data.userName.match(/(\d+)/)[0][0] !== '2'))){
                localStorage[config.tokenName] = JSON.stringify(this.session);
                document.location.reload();
                router.push('/selectApp');
              } else if (response.data.userName == 'User Not Found'){
                  return 'failed'
              } else if (isProf){
                localStorage[config.tokenName] = JSON.stringify(this.session);
                return 'isprof';
              } else {
                localStorage[config.tokenName] = JSON.stringify(this.session);
                document.location.reload();
                localStorage[config.isPre] = true;
                router.push('/pre-module');
              }     
            }).catch(err => {
              return 'failed'
          });
        
        return response;
    }

    public async loginExternal(username) {

      if (username.toLowerCase().endsWith('@hadaf.edu.pk')) {
        this.session = { userId: '', userName: '', password: '', verification: '', isEnable: 0, roleId: '' };
        let isProf = (/^prof/.test(username.toLowerCase()) || (/^principal/.test(username.toLowerCase())));
        const response = await Vue.axios({
            method: 'post',
            url: config.loginExternal,
            withCredentials: true,
            data: {
              Username: username,
            },
          }).then(response => {
              this.session = response.data[0];
              if (response.data[0].userName !== 'User Not Found'){
                localStorage[config.tokenName] = JSON.stringify(this.session);
                localStorage[config.username] = this.session.userName;
                // this.startConnection();
                // document.location.reload();
                // router.push('/selectApp');
              } else if(username == null){
                // this.authService.logout();
                return 'not auth';
              } else if (response.data[0].userName == 'User Not Found'){
                  return 'not registered';
              } else if (isProf){
                localStorage[config.tokenName] = JSON.stringify(this.session);
                return 'isprof';
              } else {
                localStorage[config.tokenName] = JSON.stringify(this.session);
                document.location.reload();
                localStorage[config.isPre] = true;
                if (this.checkPre(username)){
                  localStorage[config.isPre2] = true;
                }
                router.push('/pre-module');
              }
            }).catch(err => {
              return 'failed'
          });
        return response;
        }
        else{
            // Store the message
           return 'not exist';
          
        }
    }

    public async startConnection() {
      this.connection = new signalR.HubConnectionBuilder()
          .withUrl("https://my.hadaf.edu.pk/superappcomm?username=" + this.session.userName)
          .configureLogging(signalR.LogLevel.Information)
          .build();

        this.connection.start().then(response => {
          this.connection.on("Send", function(message) {
            console.log(message);
          });
          let username = this.session.userName.split('@')[0];
          let userData:any = [];
          this.getInfoEMS(username).then(response => {
            userData = response.data[response.data.length - 1];
          if (userData.Program){
          this.connection.invoke("AddToGroup", userData.Program, this.session.userName).then(response => {
            this.connection.invoke("AddToGroup", userData.Class, this.session.userName).then(response => {
              this.connection.invoke("AddToGroup", userData.Campus, this.session.userName).then(response => {
              document.location.reload();
              router.push('/selectApp');
          })})})}
          else {
            document.location.reload();
            router.push('/selectApp');
          }
        });
        }).catch(function (err) {
            document.location.reload();
            router.push('/selectApp');
            return console.error(err.toString());
          });
    }

    public async login(username, password) {
        this.session = { userId: '', userName: '', password: '', verification: '', isEnable: 0, roleId: '' };

        if (username === 'facebook') {
            const response = await this.service.loginUser('facebook@pgc.edu:facebook')
                .then((entity) => {
                    this.session = entity;
                    localStorage[config.tokenName] = JSON.stringify(this.session);
                    document.location.reload();
                })
                .catch((err) => {
                    console.error(`Error: ${err.message}`);
                });
            return response;
        } else {
            return this.loginpgc(username, password);
        }
    }

    public async loginpgc(username: string, password: string) {
        const param0 = username + ':' + password;
        const param1 = 'Autheticate?value=' + username + ',' + password;
        const response = await this.service.loginPgcUser(param0, param1)
            .then((entity) => {
                this.session = entity;
                localStorage[config.tokenName] = JSON.stringify(this.session);
                document.location.reload();
                router.push('/selectApp');
            })
            .catch((err) => {
                return 'failed';
            });
        return response;
    }

    public async loginCMS(username: string, password: string) {
        this.service.loginCMSUser(username, password);
    }

    public logout() {
        localStorage[config.tokenName] = null;
        localStorage[config.classLevl] = null;
        localStorage[config.isPre] = null;
        localStorage[config.isPre2] = null;
        localStorage[config.programSelect] = null;


        this.session.roleId = '';
        this.session.password = '';
        this.session.userId = '';
        this.session.userName = '';
        this.authService.logout().then(response => {
            document.location.reload();
            router.push('/');
        });
        
        
    }

    private checkPre(username) {
      let matchedNode = username.match(/(\d+)/);
      if (username && matchedNode && matchedNode[0] && matchedNode[0][0] == "2") {
        if (matchedNode[0][1] == "0" && matchedNode[0][2] == "9") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }

    public isAuthenticated() {
        return this.session !== null;
    }

    public can(permission) {
        return true; // why not?
    }
}